import { MenuBook } from '../../models';
import CourseRowList from '../CourseRowList';
import GenreRowList from '../GenreRowList';
import MenuBookRow from '../MenuBookRow';

export interface MenuBookRowListProps {
  menuBookList: MenuBook[];
}

function MenuBookRowList({ menuBookList }: MenuBookRowListProps) {
  return (
    <>
      {menuBookList.map((menuBook) => (
        <MenuBookRow key={`menubook-${menuBook.id}`} menuBook={menuBook}>
          {menuBook.genres && <GenreRowList menuBook={menuBook} />}
          {menuBook.courses && <CourseRowList menuBook={menuBook} />}
        </MenuBookRow>
      ))}
    </>
  );
}

export default MenuBookRowList;
